<!-- 我的捐赠页面
捐赠指数页面点击我的捐赠页面后跳转至该页面 -->
<template>
  <div>
    <div class="myDonation" v-if="myDonation && myDonation.length">
      <div class="recommend" v-for="item in myDonation" :key="item.createdAt">
        <div class="photoDiv">
          <div
            class="recommendTipDiv"
            v-if="item.id % 2 == 0"
            style="background: linear-gradient(-90deg, #00706E, #00706E)"
          >
            <div class="recommendTipWord">{{ item.typeName }}</div>
          </div>
          <div
            class="recommendTipDiv"
            v-else
            style="background: linear-gradient(-90deg, #00706e, #00706e)"
          >
            <div class="recommendTipWord">{{ item.typeName }}</div>
          </div>
          <van-image
            :src="item.projectInfo.images"
            alt="项目图片"
            class="recommendImg"
          />
          <div class="supportNumDiv">
            <div class="state" v-if="item.projectInfo.status == 1">进行中</div>
            <div class="state" v-else-if="item.projectInfo.status == 3">
              未开始
            </div>
            <div class="state" v-else>已结束</div>
            <!-- <div class="supportNum">
              支持人数 {{ item.projectInfo.persons }} 人
            </div> -->
          </div>
        </div>
        <div class="card clearfix">
          <div class="cardName">{{ item.projectInfo.name || " " }}</div>
          <hr />
          <div class="info">
            <div class="nowMoneyTitle">已捐赠金额：</div>
            <div class="nowMoney">{{ item.projectInfo.hasAmount }}元</div>
            <div class="certificateDiv" @click="gotoCertificate(item.donateId)">
              <img
                src="../../assets/image/btn_zhengshu_nor.png"
                alt="证书"
                class="certificateImage"
              />我的证书
            </div>
            <div class="donationBtnDiv" v-if="item.state !== 2">
              <button
                class="donationBtn"
                @click="gotoDonationDetail(item.donateId)"
              >
                再次捐赠
              </button>
            </div>
            <div class="donationBtnDiv" v-else></div>
          </div>
        </div>
      </div>
    </div>
    <div class="myNoDonation" v-else>
      <div class="noDonationDiv">
        <img
          src="../../assets/image/btn_nojuanzeng_nor.png"
          alt="图片"
          class="noDonation"
        />
      </div>
      <div class="tip">您还没有捐赠过呦~</div>
      <div class="gotoDonationDiv">
        <button class="gotoDonation" @click="gotoDonationList">去捐赠</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openid: window.localStorage.getItem("openid"),
      // openid: "oKMob64cF73I3t5_sivE238GkSGY",
      myDonation: [],
      lastPage: "",
      loading: false,
      finished: false,
    };
  },
  created() {
    this.getMyDonation();
  },
  methods: {
    async getMyDonation() {
      const result = await this.$http.get("/my/myDonate", {
        params: { openid: this.openid },
      });
      result.data = result.data || [];

      for (let i = 0; i < result.data.length; i++) {
        const item = result.data[i];
        item.projectInfo = await this.$http
          .get("/donates/getDonateById", {
            params: { id: item.donateId, openid: this.openid },
          })
          .then((res) => res.data || {});
      }

      this.myDonation = result.data;
    },

    gotoDonationDetail(donateId) {
      return this.$router.push({
        path: "/donationDetail",
        query: { id: donateId },
      });
    },
    gotoCertificate(donateId) {
      window.sessionStorage.setItem("donateId", donateId);
      return this.$router.push({
        path: "/certificate",
        query: { donateId: donateId },
      });
    },
    gotoDonationList() {
      return this.$router.push("/donationList");
    },
  },
};
</script>
<style lang="less" scoped>
.myDonation {
  position: relative;
  padding: 1.14rem;
}

.recommend {
  position: relative;
  // left: 5%;
  // width: 90%;
  margin: 0px 0px 1.14rem 0px;
  border-radius: 15px;
  border: 0.04px solid #e1e1e1;
  overflow: hidden;
}

.photoDiv {
  position: relative;
  height: 19.92rem;
}

.recommendImgDiv {
  position: relative;
  width: 100%;
  height: 20vh;
}

.recommendImg {
  width: 100%;
  height: 100%;
  border-radius: 15px 15px 0 0;
}

.recommendTipDiv {
  position: absolute;
  left: 0%;
  top: 0%;
  width: 35%;
  height: 25px;
  border-radius: 15px 0px 15px 0px;
}

.recommendTipWord {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
  white-space: nowrap;
}

.recommendTip {
  width: 100%;
}

.supportNumDiv {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #000000;
  opacity: 0.7;
}

.state {
  float: left;
  color: white;
  padding: 5px 10px 5px 5px;
  font-size: 0.9rem;
  // height: 1.5rem;
  // line-height: 1.5rem;
}

.supportNum {
  float: right;
  color: white;
  padding: 5px 10px 5px 0px;
  font-size: 0.9rem;
}

.card {
  background-color: white;
  // margin-bottom: 20px;
  border-radius: 0px 0px 15px 15px;
  // border: 1px solid #e1e1e1;
}

.cardName {
  padding: 10px 0px 10px 10px;
  font-size: 1.1rem;
  color: #333333;
  line-height: 1.2rem;
}

.info {
  display: flex;
  align-items: center;
  font-size: 1.07rem;
  color: #333333;
  line-height: 1.33rem;
  height: 3.77rem;
  padding: 0 0.76rem;
  box-sizing: border-box;
}

.nowMoneyTitle {
  float: left;
  font-weight: bold;
  //TODO
  // color: #333333;
  color: #fff;
  font-size: 1rem;
}

.nowMoney {
  float: left;
  font-weight: bold;
  //TODO
  //  color: #00706e;
  color: #fff;
  flex: 1 1 auto;
  font-size: 1.1rem;
}

.certificateDiv {
  margin-left: 1em;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #333333;
  font-size: 0.99rem;
  color: #333333;
  line-height: 1.33rem;
  font-size: 1rem;
  text-decoration-line: underline;
}

.certificateImage {
  margin-right: 2px;
  width: 4vw;
  max-width: 30px;
}

.donationBtnDiv {
  margin-left: 0.5em;
}

.donationBtn {
  color: white;
  background: linear-gradient(270deg, #00706e, #00706e);
  border-radius: 15px;
  border-color: #00706e;
  border-style: solid;
  padding: 0 5px 0 5px;
}

hr {
  width: 96%;
  border-top: 0.5px solid #e0e0e0;
  -webkit-margin-before: 0em;
  margin-block-start: 0em;
  -webkit-margin-after: 0em;
  margin-block-end: 0em;
}

.myNoDonation {
  height: 100vh;
}

.noDonationDiv {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
}

.noDonation {
  width: 100%;
}

.tip {
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translateX(-50%);
  color: #666666;
  font-size: 1.1rem;
}

.gotoDonationDiv {
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translateX(-50%);
  width: 80%;
}

.gotoDonation {
  color: white;
  background: linear-gradient(270deg, #00706e, #00706e);
  border-radius: 25px;
  border-color: #00706e;
  border-style: solid;
  width: 100%;
  padding: 7px 0px;
  font-weight: bold;
  font-size: 1.1rem;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/MyDonation.vue